import * as React from "react";
import Grid, { GridProps } from "@material-ui/core/Grid";
import OutlinedInput, { OutlinedInputProps } from "@material-ui/core/OutlinedInput";
import FormHelperText from "@material-ui/core/FormHelperText";
import useStyles from "./styles";
import { InputLabel } from "@material-ui/core";

export interface FormInputProps extends Partial<Omit<OutlinedInputProps, "error">> {
  label?: string;
  required?: boolean;
  error?: string;
  direction?: GridProps["direction"];
}

export const Label = React.memo(({ label, centered }: { label: string; centered: boolean }) => {
  const styles = useStyles();
  return (
    <Grid item>
      <Grid
        container
        className={styles.full}
        justify={centered ? "center" : undefined}
        alignContent={centered ? "center" : undefined}
      >
        <Grid item>
          <InputLabel htmlFor={label}>{label}</InputLabel>
        </Grid>
      </Grid>
    </Grid>
  );
});

const FormInput: React.FC<FormInputProps> = ({ label, error, direction, required, inputProps, ...rest }) => {
  return (
    <Grid container direction={direction || "column"} spacing={direction === "row" ? 1 : undefined}>
      {label && <Label label={`${label}${required ? "*" : ""}`} centered={direction === "row"} />}
      <Grid item>
        <OutlinedInput
          id={label}
          fullWidth
          labelWidth={0}
          error={Boolean(error)}
          required={required}
          inputProps={{
            "aria-label": label,
            ...inputProps,
          }}
          {...rest}
        />
      </Grid>
      {error && (
        <Grid item>
          <FormHelperText error>{error}</FormHelperText>
        </Grid>
      )}
    </Grid>
  );
};

export default FormInput;
